import { type PropsWithChildren, useEffect, useRef, useState } from 'react';

export default function TruncateCheck({
  children,
  suffix,
  forceTruncate,
}: PropsWithChildren<{ suffix?: string; forceTruncate?: boolean }>) {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, []);

  return (
    <div
      ref={ref}
      className='truncate'>
      {children}
      {!isTruncated && forceTruncate && <span className=''>{suffix}</span>}
    </div>
  );
}
